export const generateRandomName = () => {
  // Architectural style-inspired adjectives (Turkish)
  const adjectives = [
    // Modern & Contemporary
    'Işıltılı', 'Fütüristik', 'Dinamik', 'Yenilikçi', 'Akışkan', 'Kristal', 'Parlak', 'Cam', 
    // Classical & Traditional
    'Asil', 'Görkemli', 'Kadim', 'Tarihi', 'Otantik', 'Klasik', 'Anıtsal', 'İhtişamlı',
    // Turkish Regional
    'Anadolu', 'Boğaz', 'İstanbul', 'Haliç', 'Galata', 'Karadeniz', 'Ege', 'Akdeniz',
    // Natural & Organic
    'Doğal', 'Ahşap', 'Taş', 'Yeşil', 'Bahçeli', 'Organik', 'Rustik', 'Toprak',
    // Emotional & Atmospheric
    'Huzurlu', 'Ferah', 'Sıcacık', 'Samimi', 'Büyüleyici', 'Romantik', 'Dingin', 'Keyifli',
    // Luxurious & Elegant
    'Zarif', 'Lüks', 'Şık', 'Seçkin', 'Prestijli', 'Elit', 'Özel', 'Nadide',
    // Minimalist & Modern
    'Sade', 'Minimalist', 'Yalın', 'Dengeli', 'Geometrik', 'Çizgisel', 'Fonksiyonel', 'Rafine',
    // Funny & Quirky (Easter Eggs)
    'Çılgın', 'Uçuk', 'Komik', 'Eğlenceli', 'Şakacı', 'Muzip', 'Şanslı', 'Tuhaf',
    'ÇatıdakiKedi', 'UykucuMimar', 'DalgınUsta', 'ŞaşkınDekoratör', 'TerlikliMühendis',
    'KahveciMimar', 'PijamaliTasarımcı', 'ÇikolataSever', 'PizzacıMimar', 'ŞarkıcıDekoratör'
  ];
  
  // Architectural elements & spaces (Turkish)
  const nouns = [
    // Buildings & Structures
    'Kule', 'Köşk', 'Konak', 'Saray', 'Yalı', 'Villa', 'Malikane', 'Köprü', 'Kemer', 'Han',
    // Architectural Elements
    'Kubbe', 'Sütun', 'Revak', 'Kemer', 'Tonoz', 'Eyvan', 'Cumba', 'Şadırvan', 'Çıkma', 'Sofa',
    // Spaces & Rooms
    'Avlu', 'Divanhane', 'Selamlık', 'Harem', 'Sofa', 'Taşlık', 'Hayat', 'Limonluk', 'Hamam', 'Köşk',
    // Professional Titles
    'Mimar', 'Usta', 'Tasarımcı', 'Dekoratör', 'Ressam', 'Nakkaş', 'Hattat', 'Bezemeci',
    // Landscape Elements
    'Bahçe', 'Teras', 'Havuz', 'Çeşme', 'Şelale', 'Koruluk', 'Meydan', 'Patika',
    // Modern Spaces
    'Galeri', 'Atölye', 'Stüdyo', 'Ofis', 'Loft', 'Rezidans', 'Plaza', 'Kompleks',
    // Funny & Quirky (Easter Eggs)
    'Pasta', 'Börek', 'Simit', 'Çay', 'Kahve', 'Baklava', 'Lokum', 'Kebap',
    'Terlik', 'Pijama', 'Şapka', 'Bıyık', 'Gözlük', 'Kalem', 'Defter', 'Cetvel',
    'Kedi', 'Köpek', 'Papağan', 'Balık', 'Kaplumbağa', 'Tavşan', 'Sincap'
  ];
  
  // Architectural styles (Turkish)
  const styles = [
    'Modern', 'Barok', 'Rokoko', 'Art Deco', 'Minimalist', 'Bizans',
    'Endülüs', 'Gotik', 'Neoklasik', 'Eklektik', 'Organik', 'Brütalist', 'Fütürist',
    'Akdeniz', 'Ege', 'Karadeniz', 'Anadolu', 'Cumhuriyet'
  ];
  
  // Famous Turkish architects & locations
  const signatures = [
    'Vedat', 'Kemaleddin', 'Sedad', 'Turgut', 'Nevzat', 'Emre', 'Cengiz', 'Doğan',
    'Boğaziçi', 'Kapadokya', 'Efes', 'Mardin', 'Safranbolu', 'Bodrum', 'İzmir', 'Bursa'
  ];
  
  // Funny phrases for easter eggs
  const funnyPhrases = [
    'ÇatıdanDüşenMimar', 'KahveciUsta', 'UykucuDekoratör', 'ŞaşkınTasarımcı',
    'TerlikliMühendis', 'PijamaliMimar', 'ÇikolataSeverYapıcı', 'PizzacıDekoratör',
    'ŞarkıcıMimar', 'DansçıUsta', 'GözlüklüTasarımcı', 'BıyıklıDekoratör',
    'KediSevenMimar', 'KöpekGezdirenUsta', 'KuşBesliyenTasarımcı',
    'ÇizimYaparkenUyuyakalan', 'MaketYaparkenAcıkan', 'PlanÇizerkenŞarkıSöyleyen',
    'ÇayıSoğukİçen', 'SimidiKahveyeBatıran', 'BaklavaÜstüneKebap'
  ];

  // Generate a more complex and creative name
  const nameType = Math.floor(Math.random() * 7); // 7 different name patterns (added 2 funny ones)
  
  // Easter egg: 1% chance to get a super funny name
  if (Math.random() < 0.01) {
    return funnyPhrases[Math.floor(Math.random() * funnyPhrases.length)];
  }
  
  switch (nameType) {
    case 0: {
      // Classic adjective + noun + number
      const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
      const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
      const randomNumber = Math.floor(Math.random() * 1000);
      return `${randomAdjective}${randomNoun}${randomNumber}`;
    }
    case 1: {
      // Style + element combination
      const randomStyle = styles[Math.floor(Math.random() * styles.length)];
      const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
      const randomNumber = Math.floor(Math.random() * 100);
      return `${randomStyle}${randomNoun}${randomNumber}`;
    }
    case 2: {
      // Signature architect/location + element
      const randomSignature = signatures[Math.floor(Math.random() * signatures.length)];
      const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
      return `${randomSignature}${randomNoun}${Math.floor(Math.random() * 100)}`;
    }
    case 3: {
      // Double adjective pattern
      const randomAdj1 = adjectives[Math.floor(Math.random() * adjectives.length)];
      const randomAdj2 = adjectives[Math.floor(Math.random() * adjectives.length)];
      // Ensure we don't repeat the same adjective
      const secondAdj = randomAdj1 === randomAdj2 ? 
        adjectives[(Math.floor(Math.random() * adjectives.length) + 1) % adjectives.length] : 
        randomAdj2;
      return `${randomAdj1}${secondAdj}${Math.floor(Math.random() * 100)}`;
    }
    case 4: {
      // Poetic combination
      const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
      const randomSignature = signatures[Math.floor(Math.random() * signatures.length)];
      return `${randomAdjective}${randomSignature}${Math.floor(Math.random() * 10)}`;
    }
    case 5: {
      // Food lover architect
      const foods = ['Simit', 'Börek', 'Çay', 'Kahve', 'Baklava', 'Kebap', 'Lahmacun', 'Pide', 'Künefe', 'Dürüm'];
      const randomFood = foods[Math.floor(Math.random() * foods.length)];
      const randomNoun = ['Sever', 'Aşığı', 'Tutkunu', 'Hastası', 'Tiryakisi'][Math.floor(Math.random() * 5)];
      const randomTitle = ['Mimar', 'Usta', 'Tasarımcı', 'Dekoratör'][Math.floor(Math.random() * 4)];
      return `${randomFood}${randomNoun}${randomTitle}${Math.floor(Math.random() * 10)}`;
    }
    case 6: {
      // Funny work habit
      const habits = ['Uykucu', 'Dalgın', 'Şaşkın', 'Aceleci', 'Titiz', 'Detaycı', 'Hayalperest'];
      const randomHabit = habits[Math.floor(Math.random() * habits.length)];
      const randomTitle = ['Mimar', 'Usta', 'Tasarımcı', 'Dekoratör', 'Mühendis'][Math.floor(Math.random() * 5)];
      return `${randomHabit}${randomTitle}${Math.floor(Math.random() * 100)}`;
    }
  }
  
  // Easter egg: 0.1% chance for a legendary name
  if (Math.random() < 0.001) {
    return 'EfsaneviMimar' + Math.floor(Math.random() * 100);
  }
};
